import { render, staticRenderFns } from "./EndConfirmAccount.vue?vue&type=template&id=33af3923&scoped=true"
import script from "./EndConfirmAccount.vue?vue&type=script&lang=js"
export * from "./EndConfirmAccount.vue?vue&type=script&lang=js"
import style0 from "./EndConfirmAccount.vue?vue&type=style&index=0&id=33af3923&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af3923",
  null
  
)

export default component.exports